import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import GoalButton from "layouts/goals/components/GoalButton";
import { ORGANIZATIONS_MESSAGES } from "../organizations.constants";

// Adds an organization, or renames one (the identifier never changes).
function OrganizationFormModal({ open, onClose, onSave, isSubmitting, organization }) {
  const isEdit = !!organization;
  const [name, setName] = useState("");
  const [localError, setLocalError] = useState(null);

  useEffect(() => {
    setName(organization?.name || "");
    setLocalError(null);
  }, [organization, open]);

  const handleSave = async () => {
    if (!name.trim()) return setLocalError(ORGANIZATIONS_MESSAGES.nameRequired);
    setLocalError(null);
    await onSave({ name });
  };

  return (
    <Dialog open={open} onClose={() => !isSubmitting && onClose()} fullWidth maxWidth="xs">
      <DialogTitle>{isEdit ? "Rename organization" : "Add organization"}</DialogTitle>
      <DialogContent>
        {localError && (
          <SuiTypography variant="caption" color="error" display="block" mb={1}>
            {localError}
          </SuiTypography>
        )}
        <SuiTypography variant="caption" color="text" fontWeight="medium" display="block" mb={0.5}>
          Name
        </SuiTypography>
        <SuiInput
          autoComplete="off"
          placeholder="e.g. Acme Inc."
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        {isEdit && (
          <SuiTypography variant="caption" color="secondary" display="block" mt={1}>
            Identifier: {organization.slug}
          </SuiTypography>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <GoalButton variant="secondary" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </GoalButton>
        <GoalButton variant="primary" icon="save" loading={isSubmitting} onClick={handleSave}>
          {isEdit ? "Save changes" : "Add organization"}
        </GoalButton>
      </DialogActions>
    </Dialog>
  );
}

export default OrganizationFormModal;
